module.exports = __webpack_public_path__ + "img/cancel-event.16bc6854.svg";